exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MuiStepper-root{\n  background-color:red  \n}", ""]);

// exports
